import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-regular-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import pfp from '../../assets/pfp.jpeg';

const ChatContainer = styled.div`
  grid-area: 2 / 5 / 7 / 7;
  background: var(--main-bg);
  border-left: 1px solid var(--border-dark);
  display: flex;
  flex-direction: column;
`;

const ChatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid var(--border-dark);
`;

const ChatTitle = styled.div`
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
`;

const OnlineStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--yellow);
  font-size: 12px;
  font-weight: 600;
`;

const OnlineDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: var(--yellow);
  border-radius: 50%;
`;

const MessagesContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 15px;
  scrollbar-width: thin;
  scrollbar-color: var(--border-light) transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--border-light);
    border-radius: 2px;
  }
`;

const ChatMessage = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(79, 89, 131, 0.2);
`;

const UserAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

const MessageContent = styled.div`
  flex-grow: 1;
  font-family: 'Inter', sans-serif;
`;

const UserName = styled.div`
  color: var(--text-light);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  opacity: 0.9;
`;

const MessageText = styled.div`
  color: var(--text-white);
  font-size: 14px;
  line-height: 1.4;
`;

const ChatControls = styled.div`
  background-color: var(--chat-bg);
  border-top: 1px solid var(--border-dark);
  padding: 15px;
`;

const LanguageSelector = styled.div`
  display: flex;
  gap: 8px;
  border-radius: 6px;
  padding-top: 15px;
  margin-bottom: 10px;
`;

const LanguageOption = styled.div`
  flex: 1;
  background-color: #252F48;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #2a3868;
  }
`;

const FlagIcon = styled.img`
  width: 16px;
  height: 12px;
  object-fit: cover;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #252F48;
  border-radius: 4px;
  padding: 12px;
  min-height: 50px;
`;

const MessageInput = styled.div`
  flex-grow: 1;
  color: var(--text-white);
  font-size: 14px;
  outline: none;
  border: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
`;

const ChatRules = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--text-white);
  font-size: 12px;
  cursor: pointer;
  margin-top: 10px;
  padding: 0 5px;

  i {
    font-size: 10px;
    color: var(--text-white);
    padding-left: 10px;
  }
`;

const Chat = () => {
  return (
    <ChatContainer>
      <ChatHeader>
        <ChatTitle>LIVE CHAT</ChatTitle>
        <OnlineStatus>
          <OnlineDot />
          <span>43 ONLINE</span>
        </OnlineStatus>
      </ChatHeader>

      <MessagesContainer>
        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>janoliman</UserName>
            <MessageText>wtf<br />i just won upgrader and it's not giving me my item</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>NotTerry</UserName>
            <MessageText>Did you click off of the pop up? If you did it'll auto sell it for you with a 5% and you'll receive the balance automatically.</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>janoliman</UserName>
            <MessageText>no i think its lag or something bc when I try to upgrade again it says game active</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>janoliman</UserName>
            <MessageText>ah i got it</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>

        <ChatMessage>
          <UserAvatar src={pfp} alt="Profile" />
          <MessageContent>
            <UserName>ZargRustSnabanoditca</UserName>
            <MessageText>Tomorrow I got 1 of 3 :)<br />And hopefully I end this 7 loss stream<br />Streak*</MessageText>
          </MessageContent>
        </ChatMessage>
      </MessagesContainer>

      <ChatControls>
        <LanguageSelector>
          <LanguageOption>
            <FlagIcon src="https://flagcdn.com/w20/us.png" alt="US" />
            <span>English</span>
          </LanguageOption>
          <LanguageOption>
            <FlagIcon src="https://flagcdn.com/w20/es.png" alt="ES" />
            <span>Español</span>
          </LanguageOption>
          <LanguageOption>
            <FlagIcon src="https://flagcdn.com/w20/fr.png" alt="FR" />
            <span>Français</span>
          </LanguageOption>
        </LanguageSelector>

        <InputWrapper>
          <MessageInput contentEditable={true} />
          <FontAwesomeIcon icon={faSmile} style={{ color: 'var(--text-light)', cursor: 'pointer', marginLeft: '10px' }} />
        </InputWrapper>

        <ChatRules>
          <span>Chat Rules</span>
          <FontAwesomeIcon icon={faChevronUp} />
        </ChatRules>
      </ChatControls>
    </ChatContainer>
  );
};

export default Chat; 